<template>
    <section class="dp-layout lost-found-stats-page">
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" pane-title="组织架构" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right" v-loading="loading">
            <template v-if="schoolId > 0">
                <div class="filter-bar">
                    <el-form :inline="true" size="small" class="filter-form">
                        <el-form-item label="统计周期">
                            <el-radio-group v-model="periodType" size="small" @change="onPeriodTypeChange">
                                <el-radio-button label="week">周</el-radio-button>
                                <el-radio-button label="month">月</el-radio-button>
                                <el-radio-button label="semester">学期</el-radio-button>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item v-if="periodType === 'week' || periodType === 'semester'" label="学期">
                            <el-select v-model="filterForm.semesterId" placeholder="选择学期" style="width: 200px;" @change="onSemesterChange">
                                <el-option
                                    v-for="sem in semesterList"
                                    :key="sem.Id"
                                    :label="sem.SemesterName"
                                    :value="sem.Id"
                                />
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="periodType === 'week'" label="周次">
                            <el-select v-model="filterForm.weekNo" placeholder="选择周次" class="toolbar-field-w-week" @change="loadAllStats">
                                <el-option
                                    v-for="w in weekOptions"
                                    :key="w.value"
                                    :label="w.label"
                                    :value="w.value"
                                />
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="periodType === 'month'" label="月份">
                            <el-date-picker
                                v-model="filterForm.yearMonth"
                                type="month"
                                placeholder="选择月份"
                                value-format="yyyy-MM"
                                style="width: 140px;"
                                @change="loadAllStats"
                            />
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="loadAllStats">查询</el-button>
                            <el-button v-if="hasActionPermission('handleExport')" type="success" icon="el-icon-download" :loading="exporting" @click="handleExport">导出</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="stat-card-grid">
                    <div class="stat-card">
                        <div class="stat-icon stat-icon--blue"><i class="el-icon-box"></i></div>
                        <div class="stat-meta">
                            <div class="stat-title">有效捡拾次数</div>
                            <div class="stat-value">{{ summary.TotalFindCount || 0 }}<span class="sub-unit">次</span></div>
                        </div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-icon stat-icon--green"><i class="el-icon-user"></i></div>
                        <div class="stat-meta">
                            <div class="stat-title">参与学生数</div>
                            <div class="stat-value">{{ summary.StudentCount || 0 }}<span class="sub-unit">人</span></div>
                        </div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-icon stat-icon--orange"><i class="el-icon-office-building"></i></div>
                        <div class="stat-meta">
                            <div class="stat-title">涉及班级数</div>
                            <div class="stat-value">{{ summary.ClassCount || 0 }}<span class="sub-unit">个</span></div>
                        </div>
                    </div>
                </div>

                <div class="tables-row">
                    <div class="table-panel">
                        <div class="panel-head">
                            <div class="panel-head__left">
                                <span class="panel-title">班级捡拾汇总</span>
                                <span class="panel-hint">点击真实班级可下钻学生；「未填写班级」不可下钻</span>
                            </div>
                            <el-input
                                v-model="classKeyword"
                                size="mini"
                                clearable
                                placeholder="搜索班级/校区"
                                prefix-icon="el-icon-search"
                                class="panel-search"
                                @input="onClassSearch"
                            />
                        </div>
                        <div class="tbl-scroll-host">
                            <el-table
                                :data="pagedClassStats"
                                border
                                height="100%"
                                highlight-current-row
                                :row-class-name="classRowClassName"
                                @current-change="onClassRowChange"
                                class="compact-table"
                            >
                                <el-table-column type="index" label="排名" width="60" align="center" :index="classIndexMethod" />
                                <el-table-column label="校区" min-width="90" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ displayCampusName(row) }}</template>
                                </el-table-column>
                                <el-table-column prop="ClassName" label="班级" min-width="110" show-overflow-tooltip />
                                <el-table-column prop="FindCount" label="捡拾次数" width="90" align="center" />
                                <el-table-column prop="LastFindTime" label="最近捡拾" width="154" align="center" />
                            </el-table>
                        </div>
                        <div class="panel-pager">
                            <el-pagination
                                background
                                small
                                layout="total, sizes, prev, pager, next"
                                :total="filteredClassStats.length"
                                :current-page.sync="classPage"
                                :page-size.sync="classPageSize"
                                :page-sizes="[10, 20, 50]"
                                @size-change="onClassPageSizeChange"
                                @current-change="onClassPageChange"
                            />
                        </div>
                    </div>

                    <div class="table-panel">
                        <div class="panel-head">
                            <div class="panel-head__left">
                                <span class="panel-title">学生捡拾明细</span>
                                <span class="panel-hint">{{ studentPanelHint }}</span>
                            </div>
                            <el-input
                                v-model="studentKeyword"
                                size="mini"
                                clearable
                                placeholder="搜索姓名/学号/班级"
                                prefix-icon="el-icon-search"
                                class="panel-search"
                                @input="onStudentSearch"
                            />
                        </div>
                        <div class="tbl-scroll-host">
                            <el-table :data="pagedStudentStats" border height="100%" class="compact-table" v-loading="studentLoading">
                                <el-table-column type="index" label="排名" width="60" align="center" :index="studentIndexMethod" />
                                <el-table-column prop="StudentName" label="学生" min-width="80" show-overflow-tooltip />
                                <el-table-column prop="StudentNo" label="学号" min-width="90" show-overflow-tooltip />
                                <el-table-column prop="ClassName" label="班级" min-width="100" show-overflow-tooltip />
                                <el-table-column prop="FindCount" label="捡拾次数" width="90" align="center" />
                                <el-table-column prop="LastFindTime" label="最近捡拾" width="154" align="center" />
                            </el-table>
                        </div>
                        <div class="panel-pager">
                            <el-pagination
                                background
                                small
                                layout="total, sizes, prev, pager, next"
                                :total="filteredStudentStats.length"
                                :current-page.sync="studentPage"
                                :page-size.sync="studentPageSize"
                                :page-sizes="[10, 20, 50]"
                                @size-change="onStudentPageSizeChange"
                                @current-change="onStudentPageChange"
                            />
                        </div>
                    </div>
                </div>
            </template>

            <div v-else class="no-department-tip">
                <div class="no-department-tip__inner">
                    <i class="el-icon-school"></i>
                    <p>请在左侧选择学校或班级，查看失物统计</p>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import { getSemesterList, getSemesterWeeksBySemesterId } from '../../api/modules/misc';
import { getButtonList } from '../../promissionRouter';
import {
    getLostAndFoundStats,
    getLostAndFoundClassStats,
    getLostAndFoundStudentStats,
    exportLostAndFoundStats
} from '../../api/modules/lostAndFound';
import {
    normalizeDeptId,
    treeNodeDeptId,
    deptIdsEqual,
    resolveActiveSchoolId,
} from '../../utils/deptCascaderProps';

export default {
    name: 'LostAndFoundStats',
    components: { DepartmentPane },
    data() {
        return {
            schoolId: 0,
            schoolName: '',
            boundSchoolId: 0,
            buttonList: [],
            loading: false,
            studentLoading: false,
            exporting: false,
            periodType: 'week',
            semesterList: [],
            weekOptions: [],
            filterForm: {
                semesterId: null,
                weekNo: null,
                yearMonth: '',
                campusId: null,
                classId: null,
                classIds: null
            },
            summary: {
                TotalFindCount: 0,
                StudentCount: 0,
                ClassCount: 0,
                StartTime: null,
                EndTime: null
            },
            classStats: [],
            studentStats: [],
            activeClassId: null,
            activeClassName: '',
            classKeyword: '',
            studentKeyword: '',
            classPage: 1,
            classPageSize: 10,
            studentPage: 1,
            studentPageSize: 10
        };
    },
    computed: {
        filteredClassStats() {
            const kw = (this.classKeyword || '').trim().toLowerCase();
            if (!kw) return this.classStats;
            return this.classStats.filter(row => {
                const campus = String(row.CampusName || '').toLowerCase();
                const cls = String(row.ClassName || '').toLowerCase();
                return campus.includes(kw) || cls.includes(kw);
            });
        },
        pagedClassStats() {
            const start = (this.classPage - 1) * this.classPageSize;
            return this.filteredClassStats.slice(start, start + this.classPageSize);
        },
        filteredStudentStats() {
            const kw = (this.studentKeyword || '').trim().toLowerCase();
            if (!kw) return this.studentStats;
            return this.studentStats.filter(row => {
                const name = String(row.StudentName || '').toLowerCase();
                const no = String(row.StudentNo || '').toLowerCase();
                const cls = String(row.ClassName || '').toLowerCase();
                return name.includes(kw) || no.includes(kw) || cls.includes(kw);
            });
        },
        pagedStudentStats() {
            const start = (this.studentPage - 1) * this.studentPageSize;
            return this.filteredStudentStats.slice(start, start + this.studentPageSize);
        },
        /** 学生明细面板提示。创建于 2026-10-16 */
        studentPanelHint() {
            if (this.isUnfilledClassId(this.activeClassId)) {
                return '未填写班级无真实学生，不支持下钻';
            }
            if (this.activeClassName) {
                return '当前：' + this.activeClassName;
            }
            return '全范围学生（可点左侧班级或右侧班级行下钻）';
        }
    },
    watch: {
        '$store.state.activeSchoolId'(newSchoolId) {
            this.applySchoolChange(newSchoolId, this.$store.state.activeSchoolName);
        }
    },
    methods: {
        /** 是否为未填写班级（ClassId=0） */
        isUnfilledClassId(classId) {
            return classId === 0 || classId === '0';
        },

        /** 校区列展示：未填写班级不显示具体校区 */
        displayCampusName(row) {
            if (!row || this.isUnfilledClassId(row.ClassId)) return '—';
            return row.CampusName || '—';
        },

        /** 未填写班级行样式 */
        classRowClassName({ row }) {
            return this.isUnfilledClassId(row && row.ClassId) ? 'is-unfilled-class' : '';
        },

        /** 判断当前页面是否配置了指定按钮权限 */
        hasActionPermission(func) {
            return this.buttonList.some(button => button.Func === func);
        },

        /** 从 Blob 错误响应中读取后端提示 */
        readBlobMessage(blob) {
            return new Promise(resolve => {
                if (!blob) {
                    resolve('');
                    return;
                }
                const reader = new FileReader();
                reader.onload = () => {
                    const text = String(reader.result || '');
                    try {
                        const result = JSON.parse(text);
                        resolve(result.msg || result.message || text);
                    } catch (e) {
                        resolve(text);
                    }
                };
                reader.onerror = () => resolve('');
                reader.readAsText(blob);
            });
        },

        /** 解析当前学校 Id（字符串，避免雪花 Id 被 Number 截断）。最后修改：2026-10-18 */
        resolveSchoolId() {
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return fromStore;
            const local = normalizeDeptId(this.schoolId);
            if (local) return local;
            return '';
        },

        /**
         * 顶栏切换学校时换校重载。最后更新：2026-09-16
         */
        applySchoolChange(schoolId, schoolName) {
            const id = normalizeDeptId(schoolId);
            if (!id) return;
            if (deptIdsEqual(id, this.schoolId) && deptIdsEqual(this.boundSchoolId, id)) return;
            this.schoolId = id;
            this.boundSchoolId = id;
            if (schoolName) this.schoolName = schoolName;
            this.filterForm = {
                semesterId: null,
                weekNo: null,
                yearMonth: '',
                campusId: null,
                classId: null,
                classIds: null
            };
            this.semesterList = [];
            this.weekOptions = [];
            this.activeClassId = null;
            this.activeClassName = '';
            this.studentStats = [];
            this.classStats = [];
            this.classKeyword = '';
            this.studentKeyword = '';
            this.classPage = 1;
            this.studentPage = 1;
            this.summary = {
                TotalFindCount: 0,
                StudentCount: 0,
                ClassCount: 0,
                StartTime: null,
                EndTime: null
            };
            this.initFiltersAndLoad();
        },

        /** 从树节点向上解析指定组织类型 Id */
        findAncestorDeptId(node, orgType) {
            let cur = node;
            const target = String(orgType || '').toLowerCase();
            while (cur) {
                const data = cur.data || cur;
                const type = String((data.DeptOrgType || data.deptOrgType) || '').toLowerCase();
                if (type === target) {
                    return treeNodeDeptId(data);
                }
                cur = cur.parent;
            }
            return '';
        },

        /**
         * 收集部门节点下全部行政班 Id（含自身）。创建于 2026-10-16
         */
        collectClassIdsFromDeptData(data) {
            const ids = [];
            const seen = new Set();
            const walk = (row) => {
                if (!row) return;
                const type = String(row.DeptOrgType || row.deptOrgType || '').toLowerCase();
                const id = treeNodeDeptId(row);
                if (type === 'class' && id && !seen.has(id)) {
                    seen.add(id);
                    ids.push(id);
                }
                const children = row.children || [];
                for (let i = 0; i < children.length; i++) {
                    walk(children[i]);
                }
            };
            walk(data);
            return ids;
        },

        /**
         * 左侧组织树选中：学校/校区/年级/班级驱动统计范围。最后更新：2026-10-16
         */
        async treeNodeClick(data, node) {
            if (!data) return;
            const orgType = String(data.DeptOrgType || data.deptOrgType || '').toLowerCase();
            const deptId = treeNodeDeptId(data);
            if (!deptId) return;

            const schoolId = orgType === 'school' || orgType === 'affiliateschool'
                ? deptId
                : (this.findAncestorDeptId(node, 'school')
                    || this.findAncestorDeptId(node, 'affiliateschool')
                    || this.resolveSchoolId()
                    || normalizeDeptId(this.schoolId));
            if (!schoolId) return;

            const schoolChanged = !deptIdsEqual(schoolId, this.schoolId);
            this.schoolId = schoolId;
            this.boundSchoolId = schoolId;
            if (orgType === 'school' || orgType === 'affiliateschool') {
                this.schoolName = data.label || data.Name || this.schoolName;
            }

            let campusId = null;
            let classId = null;
            let classIds = null;
            if (orgType === 'campus') {
                campusId = deptId;
            } else if (orgType === 'class') {
                classId = deptId;
                campusId = this.findAncestorDeptId(node, 'campus') || null;
            } else if (orgType === 'grade' || orgType === 'period' || orgType === 'stage') {
                campusId = this.findAncestorDeptId(node, 'campus') || null;
                classIds = this.collectClassIdsFromDeptData(data);
            }

            this.filterForm.campusId = campusId;
            this.filterForm.classId = classId;
            this.filterForm.classIds = classIds;
            this.activeClassId = classId;
            this.activeClassName = classId ? (data.label || data.Name || '') : '';
            this.classPage = 1;
            this.studentPage = 1;

            if (schoolChanged) {
                this.filterForm.semesterId = null;
                this.filterForm.weekNo = null;
                this.filterForm.yearMonth = '';
                this.semesterList = [];
                this.weekOptions = [];
                await this.initFiltersAndLoad();
                return;
            }
            await this.loadAllStats();
        },

        async initFiltersAndLoad() {
            if (!this.schoolId) return;
            this.loading = true;
            try {
                await this.loadSemesterList();
                this.ensureDefaultPeriodFields();
                await this.loadAllStats();
            } finally {
                this.loading = false;
            }
        },

        async loadSemesterList() {
            try {
                const res = await getSemesterList({ departmentId: this.schoolId });
                if (res && res.success) {
                    this.semesterList = res.response || [];
                    const exists = this.semesterList.some(s => String(s.Id) === String(this.filterForm.semesterId));
                    if (!exists) {
                        this.filterForm.semesterId = null;
                        this.filterForm.weekNo = null;
                        this.weekOptions = [];
                    }
                    if (!this.filterForm.semesterId && this.semesterList.length) {
                        const current = this.semesterList.find(s => s.IsCurrent || s.isCurrent) || this.semesterList[0];
                        this.filterForm.semesterId = current.Id;
                    }
                    if (this.periodType === 'week' && this.filterForm.semesterId) {
                        await this.loadWeekOptions();
                    }
                } else {
                    this.semesterList = [];
                    this.filterForm.semesterId = null;
                    this.filterForm.weekNo = null;
                    this.weekOptions = [];
                }
            } catch (err) {
                this.semesterList = [];
                this.filterForm.semesterId = null;
                this.filterForm.weekNo = null;
                this.weekOptions = [];
            }
        },

        /** 加载周次选项（字段为 WeekNumber）；默认选中包含今天的周。最后更新：2026-09-16 */
        async loadWeekOptions() {
            if (!this.filterForm.semesterId) {
                this.weekOptions = [];
                return;
            }
            try {
                const res = await getSemesterWeeksBySemesterId({ semesterId: this.filterForm.semesterId });
                const list = (res.data && res.data.success) ? (res.data.response || []) : [];
                const today = this.formatDateYmd(new Date());
                let currentWeekNo = null;
                (list || []).forEach(w => {
                    if (currentWeekNo != null) return;
                    const weekNo = w.WeekNumber != null ? w.WeekNumber : (w.weekNumber != null ? w.weekNumber : null);
                    const days = w.Days || w.days || [];
                    if (weekNo != null && Array.isArray(days)
                        && days.some(d => this.formatDateYmd(d.Date || d.date) === today)) {
                        currentWeekNo = weekNo;
                    }
                });

                this.weekOptions = (list || []).map(w => {
                    const weekNo = w.WeekNumber != null ? w.WeekNumber : (w.weekNumber != null ? w.weekNumber : null);
                    const days = w.Days || w.days || [];
                    let firstDate = '';
                    let lastDate = '';
                    if (Array.isArray(days) && days.length) {
                        firstDate = this.formatDateYmd(days[0].Date || days[0].date);
                        lastDate = this.formatDateYmd(days[days.length - 1].Date || days[days.length - 1].date);
                    }
                    const isCurrent = currentWeekNo != null && String(currentWeekNo) === String(weekNo);
                    const label =
                        firstDate && lastDate
                            ? `第${weekNo}周 (${firstDate} ~ ${lastDate})${isCurrent ? '（本周）' : ''}`
                            : `第${weekNo}周${isCurrent ? '（本周）' : ''}`;
                    return { value: weekNo, label };
                }).filter(w => w.value != null);

                if (this.weekOptions.length) {
                    const weekExists = this.weekOptions.some(w => String(w.value) === String(this.filterForm.weekNo));
                    if (!weekExists) {
                        const preferred = currentWeekNo != null
                            ? this.weekOptions.find(w => String(w.value) === String(currentWeekNo))
                            : null;
                        this.filterForm.weekNo = preferred ? preferred.value : this.weekOptions[0].value;
                    }
                } else {
                    this.filterForm.weekNo = null;
                }
            } catch (err) {
                this.weekOptions = [];
            }
        },

        /** 格式化为 yyyy-MM-dd */
        formatDateYmd(value) {
            if (!value) return '';
            if (value instanceof Date && !isNaN(value.getTime())) {
                const y = value.getFullYear();
                const m = String(value.getMonth() + 1).padStart(2, '0');
                const d = String(value.getDate()).padStart(2, '0');
                return `${y}-${m}-${d}`;
            }
            const text = String(value).trim();
            if (!text) return '';
            if (/^\d{4}-\d{2}-\d{2}/.test(text)) return text.slice(0, 10);
            const parsed = new Date(text);
            if (!isNaN(parsed.getTime())) return this.formatDateYmd(parsed);
            return text.split(' ')[0] || '';
        },

        ensureDefaultPeriodFields() {
            if (this.periodType === 'month' && !this.filterForm.yearMonth) {
                const now = new Date();
                const m = String(now.getMonth() + 1).padStart(2, '0');
                this.filterForm.yearMonth = `${now.getFullYear()}-${m}`;
            }
        },

        async onPeriodTypeChange() {
            this.activeClassId = null;
            this.activeClassName = '';
            this.studentStats = [];
            this.classPage = 1;
            this.studentPage = 1;
            this.ensureDefaultPeriodFields();
            if ((this.periodType === 'week' || this.periodType === 'semester') && !this.semesterList.length) {
                await this.loadSemesterList();
            }
            if (this.periodType === 'week' && this.filterForm.semesterId) {
                await this.loadWeekOptions();
            }
            this.loadAllStats();
        },

        async onSemesterChange() {
            this.filterForm.weekNo = null;
            if (this.periodType === 'week') {
                await this.loadWeekOptions();
            }
            this.loadAllStats();
        },

        /** 组装统计查询参数 */
        buildStatsParams(extra) {
            const params = {
                schoolId: this.schoolId,
                periodType: this.periodType,
                ...(extra || {})
            };
            if (this.filterForm.campusId) params.campusId = this.filterForm.campusId;
            if (this.filterForm.classIds && this.filterForm.classIds.length) {
                params.classIds = this.filterForm.classIds.join(',');
            } else if (this.filterForm.classId) {
                params.classId = this.filterForm.classId;
            }
            if (this.periodType === 'week') {
                if (this.filterForm.semesterId) params.semesterId = this.filterForm.semesterId;
                if (this.filterForm.weekNo != null && this.filterForm.weekNo !== '') params.weekNo = this.filterForm.weekNo;
            } else if (this.periodType === 'month') {
                if (this.filterForm.yearMonth) params.yearMonth = this.filterForm.yearMonth;
            } else if (this.periodType === 'semester') {
                if (this.filterForm.semesterId) params.semesterId = this.filterForm.semesterId;
            }
            return params;
        },

        async loadAllStats() {
            if (!this.schoolId) return;
            // 选了年级/学段但节点下没有班级时，不退化为校区全量
            if (Array.isArray(this.filterForm.classIds) && this.filterForm.classIds.length === 0) {
                this.summary = { TotalFindCount: 0, StudentCount: 0, ClassCount: 0 };
                this.classStats = [];
                this.studentStats = [];
                return;
            }
            this.loading = true;
            try {
                const params = this.buildStatsParams();
                const [summaryRes, classRes] = await Promise.all([
                    getLostAndFoundStats(params),
                    getLostAndFoundClassStats(params)
                ]);
                if (summaryRes.data && summaryRes.data.success) {
                    this.summary = summaryRes.data.response || {
                        TotalFindCount: 0,
                        StudentCount: 0,
                        ClassCount: 0
                    };
                } else {
                    this.summary = { TotalFindCount: 0, StudentCount: 0, ClassCount: 0 };
                }
                if (classRes.data && classRes.data.success) {
                    this.classStats = classRes.data.response || [];
                } else {
                    this.classStats = [];
                }
                this.classPage = 1;
                await this.loadStudentStats(this.activeClassId);
            } catch (err) {
                this.$message.error('加载统计失败');
            } finally {
                this.loading = false;
            }
        },

        onClassRowChange(row) {
            if (!row) {
                this.activeClassId = null;
                this.activeClassName = '';
                this.loadStudentStats(null);
                return;
            }
            // ClassId=0 是虚拟「未填写班级」，不能按下钻查学生（0 会被当成未传班级）。创建于 2026-10-16
            if (this.isUnfilledClassId(row.ClassId)) {
                this.activeClassId = 0;
                this.activeClassName = row.ClassName || '未填写班级';
                this.studentStats = [];
                this.studentPage = 1;
                return;
            }
            this.activeClassId = row.ClassId;
            this.activeClassName = row.ClassName || '';
            this.studentPage = 1;
            this.loadStudentStats(row.ClassId);
        },

        async loadStudentStats(classId) {
            if (!this.schoolId) return;
            // 显式传入 0，或当前选中未填写班级时，不请求学生明细
            if (this.isUnfilledClassId(classId)) {
                this.studentStats = [];
                this.studentPage = 1;
                return;
            }
            this.studentLoading = true;
            try {
                const effectiveClassId = classId != null && classId !== ''
                    ? normalizeDeptId(classId)
                    : normalizeDeptId(this.filterForm.classId);
                const params = this.buildStatsParams(
                    effectiveClassId ? { classId: effectiveClassId } : {}
                );
                // 若当前树选的是年级多班，且未指定单班，保留 classIds；单班下钻时覆盖为 classId
                if (effectiveClassId && params.classIds) {
                    delete params.classIds;
                }
                const res = await getLostAndFoundStudentStats(params);
                if (res.data && res.data.success) {
                    this.studentStats = res.data.response || [];
                } else {
                    this.studentStats = [];
                }
                this.studentPage = 1;
            } catch (err) {
                this.studentStats = [];
            } finally {
                this.studentLoading = false;
            }
        },

        onClassSearch() {
            this.classPage = 1;
        },

        onStudentSearch() {
            this.studentPage = 1;
        },

        onClassPageChange(page) {
            this.classPage = page;
        },

        onClassPageSizeChange(size) {
            this.classPageSize = size;
            this.classPage = 1;
        },

        onStudentPageChange(page) {
            this.studentPage = page;
        },

        onStudentPageSizeChange(size) {
            this.studentPageSize = size;
            this.studentPage = 1;
        },

        classIndexMethod(index) {
            return (this.classPage - 1) * this.classPageSize + index + 1;
        },

        studentIndexMethod(index) {
            return (this.studentPage - 1) * this.studentPageSize + index + 1;
        },

        async handleExport() {
            if (!this.schoolId) return;
            if (!(this.summary && this.summary.TotalFindCount > 0) &&
                !(this.studentStats && this.studentStats.length > 0)) {
                this.$message.warning('没有数据可导出');
                return;
            }
            this.exporting = true;
            try {
                const response = await exportLostAndFoundStats(this.buildStatsParams());
                if (!response.data) {
                    this.$message.error('导出数据为空');
                    return;
                }
                const contentType = String((response.headers &&
                    (response.headers['content-type'] || response.headers['Content-Type'])) || '').toLowerCase();
                const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: contentType });
                if (!contentType.includes('spreadsheetml') && !contentType.includes('application/octet-stream')) {
                    const message = await this.readBlobMessage(blob);
                    this.$message.error(message || '导出失败');
                    return;
                }
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', '失物统计.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (err) {
                if (!err || !err.bizMessage) {
                    this.$message.error('导出失败');
                }
            } finally {
                this.exporting = false;
            }
        }
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        // 学校范围页由 DepartmentPane 初始化时自动 emit tree-node-click，避免与此处重复请求
    }
};
</script>

<style scoped>
.filter-bar {
    margin-bottom: 8px;
    flex-shrink: 0;
}

.filter-form .el-form-item {
    margin-bottom: 6px;
}

.stat-card-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 14px;
    flex-shrink: 0;
}

.stat-card {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 14px 16px;
}

.stat-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    color: #fff;
    font-size: 20px;
}

.stat-icon--blue { background: #409EFF; }
.stat-icon--green { background: #67C23A; }
.stat-icon--orange { background: #E6A23C; }

.stat-title {
    font-size: 13px;
    color: #909399;
    margin-bottom: 4px;
}

.stat-value {
    font-size: 24px;
    font-weight: 700;
    color: #303133;
    line-height: 1.2;
}

.sub-unit {
    font-size: 13px;
    font-weight: 400;
    color: #909399;
    margin-left: 4px;
}

/* 双表区域吃满右侧剩余高度。最后更新：2026-09-12 */
.tables-row {
    flex: 1 1 auto;
    min-height: 0;
    height: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    overflow: hidden;
}

.table-panel {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 10px;
    background: #fff;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
    flex-shrink: 0;
}

.panel-head__left {
    display: flex;
    align-items: baseline;
    gap: 8px;
    min-width: 0;
}

.panel-title {
    font-weight: 600;
    color: #303133;
    white-space: nowrap;
}

.panel-hint {
    font-size: 12px;
    color: #909399;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.panel-search {
    width: 180px;
    flex-shrink: 0;
}

.table-panel > .tbl-scroll-host {
    flex: 1 1 auto;
    min-height: 0;
    height: 0;
    width: 100%;
    overflow: hidden;
}

.table-panel > .tbl-scroll-host > .el-table {
    width: 100%;
    height: 100%;
}

.panel-pager {
    margin-top: 8px;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
}

.no-department-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 200px;
    color: #909399;
}

.no-department-tip i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #c0c4cc;
}

.compact-table .is-unfilled-class {
    color: #909399;
}

@media (max-width: 1200px) {
    .stat-card-grid,
    .tables-row {
        grid-template-columns: 1fr;
        height: auto;
    }

    .tables-row {
        overflow: visible;
    }

    .table-panel > .tbl-scroll-host {
        height: 360px;
        flex: none;
    }
}
</style>
